import { render, staticRenderFns } from "./MyCompensation.vue?vue&type=template&id=a581ff9e&scoped=true"
import script from "./MyCompensation.vue?vue&type=script&lang=js"
export * from "./MyCompensation.vue?vue&type=script&lang=js"
import style0 from "./MyCompensation.vue?vue&type=style&index=0&id=a581ff9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a581ff9e",
  null
  
)

export default component.exports